import styled from "styled-components";

export const Container = styled.div`
  overflow: hidden;
  margin: 0 30px;
`;
